import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouteConfigLoadStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { Subscription } from 'rxjs';

/**
 * Casca da aplicacao: header, sidebar e o <router-outlet>.
 *
 * Alem de posicionar as pecas, mostra um skeleton de pagina enquanto a rota
 * carrega. As 32 rotas filhas do layout em routes.ts sao `loadChildren`: entre
 * o clique no menu e o primeiro desenho da tela ha o download do modulo, e ate
 * aqui esse intervalo era a tela anterior parada. E o que cobre as telas que
 * nao carregam dado (home, exportacao de CSV) e o primeiro instante de todas
 * as outras -- decisao 5 do projeto P-HUB-143. Login, recuperacao de senha e
 * paginas de erro ficam fora do layout, e a primeira carga do app e do
 * preloader de boot (src/app/core/preloader): o layout so existe depois dela.
 *
 * So RouteConfigLoadStart liga o skeleton: modulo ja baixado nao dispara o
 * evento, e a navegacao entre telas dele nao passa por aqui. Mesmo no
 * download, o skeleton so entra se passar de ATRASO_MS -- um skeleton que
 * pisca e pior que nenhum.
 */
@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent implements OnInit, OnDestroy {

    private static readonly ATRASO_MS = 150;

    /** o modulo da rota ainda esta sendo baixado, ha mais de ATRASO_MS */
    carregandoRota = false;

    private eventos: Subscription;
    private temporizador: any = null;

    constructor(private router: Router) { }

    ngOnInit() {
        this.eventos = this.router.events.subscribe(ev => {
            if (ev instanceof RouteConfigLoadStart) {
                this.liga();
            } else if (ev instanceof NavigationEnd || ev instanceof NavigationCancel || ev instanceof NavigationError) {
                this.desliga();
            }
        });
    }

    ngOnDestroy() {
        if (this.eventos) { this.eventos.unsubscribe(); }
        this.desliga();
    }

    private liga(): void {
        if (this.temporizador !== null || this.carregandoRota) { return; }
        this.temporizador = setTimeout(() => {
            this.temporizador = null;
            this.carregandoRota = true;
        }, LayoutComponent.ATRASO_MS);
    }

    private desliga(): void {
        if (this.temporizador !== null) {
            clearTimeout(this.temporizador);
            this.temporizador = null;
        }
        this.carregandoRota = false;
    }
}
